import {
  ProjectManagementProjectDetailsPageSettingsBudgetSectionDeleteCostPlanningDocument,
  ProjectManagementProjectDetailsPageSettingsBudgetSectionDeleteCostPlanningMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

interface deleteFixedCostPlanningDto {
  id: number
}

export const useDeleteFixedCostPlanning = () => {
  const [deleteFixedCostPlanning] = useMutation(
    ProjectManagementProjectDetailsPageSettingsBudgetSectionDeleteCostPlanningDocument,
    {
      extractorFn: (
        data: ProjectManagementProjectDetailsPageSettingsBudgetSectionDeleteCostPlanningMutation
      ) => data.projectManagementMutations.deleteProjectmanagementFixedCostPlanning,
    }
  )
  return {
    delete(dto: deleteFixedCostPlanningDto) {
      const { id: fixedCostPlanningId } = dto
      return deleteFixedCostPlanning({
        variables: {
          id: fixedCostPlanningId,
        },
        update(cache, mutationResult) {
          const newBudget =
            mutationResult.data?.projectManagementMutations.deleteProjectmanagementFixedCostPlanning
          if (newBudget) {
            cache.evict({
              id: cache.identify({
                id: fixedCostPlanningId,
                __typename: 'ProjectManagementFixedCostPlanning',
              }),
            })
          }
        },
      })
    },
  }
}
